import _get from 'lodash/get';
import _capitalize from 'lodash/capitalize';

import { defaultKeys, insertKeys } from '@/lib/vuexUtils';


const valueType = (item) => {
  if (item.typeid === 'FAB') return 'value';
  if (item.typeid === 'WAR') return 'warranty';
  return '';
};

const localState = {
  selectedOrder: null,
  selectedParentPath: 'record.orders[0]',
  isQueryingSchedules: false,
  sequence: 0,
};

const localGetters = {
  selectedOrder: state => state.selectedOrder,
  selectedParentPath: state => state.selectedParentPath,
  isQueryingSchedules: state => state.isQueryingSchedules,
  getAttachmentSettings: (state, getters, rootState, rootGetters) => item => {
    const attachmentType = valueType(item);
    const capitalizedAttachMentType = _capitalize(attachmentType);
    const scope = rootGetters['meta/systemParameter'](`${attachmentType}product_scope`);
    const coverAll = rootGetters['preferences/getPreference'](`CoverAllFor${capitalizedAttachMentType}Product`);
    const coverRelated = rootGetters['preferences/getPreference'](`${capitalizedAttachMentType}ProductCoverageFromRelated`);
    // references:
    // valueproduct_scope, warrantyproduct_scope,
    // CoverAllForValueProduct, CoverAllForWarrantyProduct,
    // ValueProductCoverageFromRelated, WarrantyProductCoverageFromRelated
    return {
      attachmentType,
      scope,
      cover_all: _get(coverAll, 'preference.value', null),
      cover_related: _get(coverRelated, 'preference.value', null),
    };
  },
  // NOTE: shipemail is NOT pulled from the customer record as it doesn't exist in GERS
  shipToMap: () => {
    return {
      shipfirstname: 'firstname',
      shiplastname: 'lastname',
      shipsuffix: 'suffix',
      shipcompanyname: 'companyname',
      shipaddress1: 'address1',
      shipaddress2: 'address2',
      shipcity: 'city',
      shipstate: 'state',
      shipzipcode: 'zipcode',
      shipphonenumber: 'phonenumber',
      shipbusinessphone: 'businessphone',
      shipextension: 'extension',
      shipcountryid: 'countryid',
    };
  },
  adjustmentPermissions: (state, getters, rootState, rootGetters) => {
    const checkPermission = (permission) => rootGetters['permissions/isPermPresent'](permission);
    return {
      MCR: checkPermission('ordercreatecredit'),
      MDB: checkPermission('ordercreatedebit'),
      EEX: checkPermission('ordercreateexchange'),
      CRM: checkPermission('ordercreatereturn'),
      SER: checkPermission('ordercreateservice'),
    };
  },
  allAdjustmentPermsPresent: (state, getters) => {
    return Object.values(getters.adjustmentPermissions).some(value => value);
  },
  currentSequence: state => state.sequence,
};

const localActions = {
  setSelectedOrder({ commit }, order) {
    commit('set_selected_order', order);
  },
  setSelectedParentPath({ commit }, path) {
    commit('set_selected_parent_path', path);
  },
  isQueryingSchedules({ commit }, bool) {
    commit('set_query_schedule_flag', bool);
  },
  setSequence({ commit }, sequence) {
    commit('set_sequence', sequence);
  },
  async getReplacementSale({ rootState, dispatch }, params) {
    const { results, errors } = await dispatch(
      'editObject/post',
      {
        url: '/tg/customerorder/create_replacement_sale',
        params,
      },
      { root: true },
    );
    if (errors) {
      const text = _get(results, '[0][1]') || 'Unknown error';
      await dispatch(
        'notify/push',
        {
          title: 'Replacement Sale Error',
          text,
        },
        { root: true },
      );
      return null;
    }
    insertKeys(defaultKeys, results[0], rootState.meta);
    return results[0];
  },
};

const localMutations = {
  set_selected_order(state, order) {
    state.selectedOrder = order;
  },
  set_selected_parent_path(state, path) {
    state.selectedParentPath = path;
  },
  set_query_schedule_flag(state, bool) {
    state.isQueryingSchedules = bool;
  },
  set_sequence(state, sequence) {
    state.sequence = sequence;
  },
};

export default {
  namespaced: true,
  state: localState,
  getters: localGetters,
  actions: localActions,
  mutations: localMutations,
};
